<template>
  <div>
    <!-- Loading state -->
    <ContentSkeleton
      v-if="isLoading || !isDataReady"
      :variant="subform ? 'form' : 'accordion'"
      :rows="subform ? 4 : 10"
      :with-title="false"
    />
    <!-- Form content -->
    <div v-else>
      <!-- Debug del formData -->
      <div v-if="false" class="mb-4 p-3 border rounded bg-light">
        <h6 class="text-primary">Debug FormData:</h6>
        <pre class="mb-0" style="max-height: 200px; overflow-y: auto">{{
          JSON.stringify(formData, null, 2)
        }}</pre>
      </div>
      <form @submit.prevent="" :class="'form-' + selectedModel">
        <div :class="multiple ? 'w-100' : 'row p-2 form2-field-row'">
          <div
            v-for="(field, idx) in visibleFields"
            :key="field.key || idx"
            :class="getContainerClass(field)"
            :style="field.type === 'group' && !canEditVisualGroup(field) ? 'display: none;' : ''"
          >
            <div
              v-if="
                field.type === 'group' &&
                getVisualGroupType(field.key) === 'box'
              "
              class=""
            >
              <label class="form-label cursor-pointer p-2 text-secondary">
                <GroupIcon v-if="field.icon" :icon="field.icon" />
                {{ $t(field.label) }}
              </label>
            </div>

            <div
              v-if="
                field.type === 'group' &&
                (getVisualGroupType(field.key) === 'fieldset' || field.isArray)
              "
              class="col-md-12 p-0"
              :class="field.key"
            >
              <label
                :for="field.key"
                class="form-label cursor-pointer w-100"
                :class="getClassFieldset(field)"
                @click="open === field.key ? (open = '') : (open = field.key)"
                v-if="!isSubGroup(field)"
              >
                
                <template v-if="useFontAwesomeGroupIcons">
                  <i
                    v-if="open == field.key"
                    class="fas fa-chevron-down text-white"
                    style="font-size: 1.1rem"
                    aria-hidden="true"
                  ></i>
                  <i
                    v-else
                    class="fas fa-chevron-right text-secondary"
                    style="font-size: 1rem"
                    aria-hidden="true"
                  ></i>
                </template>
                <template v-else>
                  <i class="material-icons" v-if="open == field.key" :class="'text-white'"
                    >keyboard_arrow_down</i
                  >
                  <i class="material-icons" v-else>keyboard_arrow_right</i>
                </template>
                <span class="p-2">{{ $t(field.label) }} </span>
                <span v-if="field.description" class="ml-4 badge badge-danger">
                  {{ field.description }}
                </span><span v-if="field.tooltip" class="ml-4 badge badge-primary">
                  {{ field.tooltip }}
                </span>
              </label>
              <label
                v-else-if="visualgrouptype == 'fieldset'"
                :for="field.key"
                class="form-label cursor-pointer w-100"
                :class="getClassFieldset(field)"
              >
                <GroupIcon v-if="field.icon" :icon="field.icon" />
                <i class="material-icons" v-else>{{ field.label2 }}</i>
                {{ $t(field.label) }}
                <span
                  v-if="field.tooltip"
                  class="tooltip-icon"
                  :title="field.tooltip"
                >
                  <i
                    class="material-icons text-info ml-1"
                    style="font-size: 16px; cursor: help"
                    >info</i
                  >
                </span>
              </label>
            </div>
            <small
              :for="field.key"
              class="form-label w-100 text-secondary position-relative"
              :class="formData[field.key] ? 'text-primary' : 'text-secondary'"
              v-else
            >
              {{ $t(field.label) }}
              <span
                v-if="field.tooltip"
                class="tooltip-icon"
                :title="field.tooltip"
              >
                <i
                  class="material-icons text-info ml-1"
                  style="font-size: 16px; cursor: help"
                  >info</i
                >
              </span>
              <small class="text-danger" v-if="field.required">
                * required</small
              >
            </small>

            <span class="text-danger" v-if="field.errorMessage">
              {{ field.errorMessage }}
            </span>

            <!-- Campo select - Usando FieldSelect de model-definition-core -->
            <FieldSelect
              v-if="field.type === 'select' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo múltiple simple -->
            <div
              v-if="
                field.isArray &&
                ['string', 'number', 'boolean', 'date', 'email'].includes(field.type)
              "
            >
              <div
                :class="
                  field.type == 'group' && field.isArray ? 'group-multiple' : ''
                "
              >
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>{{ $t(field.label) }}</th>
                      <th style="width: 100px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in formData[field.key]" :key="idx">
                      <td>
                        <!-- Campo de texto/string/email en array -->
                        <FieldText
                          v-if="['string', 'text', 'email'].includes(field.type)"
                          :field="field"
                          :value="formData[field.key][idx]"
                          mode="edit"
                          :fieldId="`${getFieldId(field.key)}_${idx}`"
                          :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
                          :showLabel="false"
                          @input="(val) => onFieldChange(field.key, val, idx)"
                          @update:editingFields="editingFields = $event"
                        />
                        <!-- Campo numérico en array -->
                        <FieldNumber
                          v-else-if="field.type === 'number'"
                          :field="field"
                          :value="formData[field.key][idx]"
                          mode="edit"
                          :fieldId="`${getFieldId(field.key)}_${idx}`"
                          :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
                          :parentItem="formData"
                          :showLabel="false"
                          @input="(val) => onFieldChange(field.key, val, idx)"
                          @update:editingFields="editingFields = $event"
                        />
                        <!-- Campo booleano en array -->
                        <FieldBoolean
                          v-else-if="field.type === 'boolean'"
                          :field="field"
                          :value="formData[field.key][idx]"
                          mode="edit"
                          :fieldId="`${getFieldId(field.key)}_${idx}`"
                          :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
                          :showLabel="false"
                          @input="(val) => onFieldChange(field.key, val, idx)"
                          @update:editingFields="editingFields = $event"
                        />
                        <!-- Campo de fecha en array -->
                        <FieldDate
                          v-else-if="field.type === 'date'"
                          :field="field"
                          :value="formData[field.key][idx]"
                          mode="edit"
                          :fieldId="`${getFieldId(field.key)}_${idx}`"
                          :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
                          :showLabel="false"
                          @input="(val) => onFieldChange(field.key, val, idx)"
                          @update:editingFields="editingFields = $event"
                        />
                      </td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="removeArrayItem(field.key, idx)"
                        >
                          <i class="material-icons">delete</i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2">
                <button
                  type="button"
                  class="btn btn-sm btn-secondary"
                  @click="addArrayItem(field)"
                >
                  <i class="material-icons">add</i> Agregar
                </button>
              </div>
            </div>
            <!-- Campo tipo reference - Usando FieldReference de model-definition-core (oculto si field.hide) -->
            <FieldReference
              v-if="field.type === 'reference' && field.ref && !field.isArray && !field.hide"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
              @open-reference-modal="openReferenceModal"
            />

            <!-- Campo de texto - Usando FieldText de model-definition-core -->
            <FieldText
              v-else-if="field.type === 'string' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />
            <!-- Campo de área de texto - Usando FieldText de model-definition-core -->
            <FieldText
              v-else-if="field.type === 'textarea' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo de fecha - Usando FieldDate de model-definition-core -->
            <FieldDate
              v-else-if="field.type === 'date' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo numérico - Usando FieldNumber de model-definition-core -->
            <FieldNumber
              v-else-if="field.type === 'number' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :parentItem="formData"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo autoincrement -->
            <AutoIncrementField
              v-else-if="field.type === 'autoincrement'"
              :field="field"
              :value="formData[field.key]"
              :modelName="selectedModel || modelName"
              :required="field.required"
              :readonly="field.readonly"
              :editingFields="editingFields"
              @input="(val) => onFieldChange(field.key, val)"
              @invoice-number-preview="onInvoiceNumberPreview"
              @update:editingFields="
                (val) => $emit('update:editingFields', val)
              "
              @updateDateField="updateDateField"
            />

            <!-- Campo booleano - Usando FieldBoolean de model-definition-core -->
            <FieldBoolean
              v-else-if="field.type === 'boolean' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo imagen -->
            <FieldImage
              v-else-if="field.type === 'image'"
              :value="formData[field.key]"
              :field="field"
              :fieldId="getFieldId(field.key)"
              @input="(val) => onFieldChange(field.key, val)"
              @pending-file="(file) => handlePendingImageFile(field.key, file)"
              @pending-files="(files) => handlePendingImageFiles(field.key, files)"
              @remove-pending-file="(index) => handleRemovePendingImageFile(field.key, index)"
            />
            <!-- Campo array de objetos -->

            <!-- Campo grupo simple (no múltiple) -->
            <div
              v-else-if="field.type === 'group' && !field.isArray"
              class="tabs-group row m-0"
              :class="getBoxClass(field.key)"
            >
              <div>
                <Form
                  :fields="field.fields"
                  :value="formData[field.key]"
                  @input="
                    (val) => {
                      handleGroupInput(field.key, val);
                    }
                  "
                  @button-click="
                    (val) => {
                      $emit('button-click', val);
                    }
                  "
                  :lists="lists"
                  :models="models"
                  :selectedModel="selectedModel"
                  :modelDefinitions="modelDefinitions"
                  :visualgrouptype="getVisualGroupType(field.key)"
                  :defaultRules="defaultRules ? defaultRules : rules"
                  :subform="true"
                  :showButtons="false"
                  :id-prefix="getFieldId(field.key)"
                  @submit.prevent
                />
              </div>
            </div>

            <!-- Campo múltiple grupo -->
            <div
              v-else-if="field.isArray && field.type === 'group'"
              class="float-left p-2 mb-4 border border-primary rounded group-multiple-block"
            >
              <div
                :class="
                  field.type == 'group' && field.isArray ? 'group-multiple' : ''
                "
              >
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th
                        v-for="subField in visibleGroupFields(field)"
                        :key="subField.key"
                        class="text-secondary"
                      >
                        <small>
                          <strong> {{ $t(subField.label) }}</strong>
                        </small>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in formData[field.key]" :key="idx">
                      <td
                        v-for="subField in visibleGroupFields(field)"
                        :key="subField.key"
                      >
                        <Form
                          :fields="[subField]"
                          :value="formData[field.key][idx]"
                          @input="
                            (val) => {
                              // Asegurarse de que el valor sea un objeto
                              const updatedValue =
                                typeof val === 'object'
                                  ? val
                                  : { [subField.key]: val };
                              // Actualizar el item en el array
                              formData[field.key][idx] = updatedValue;
                              // Emitir el cambio
                              $emit('input', formData);
                            }
                          "
                          :lists="lists"
                          :models="models"
                          :selectedModel="selectedModel"
                          :modelDefinitions="modelDefinitions"
                          :showButtons="false"
                          :visualgrouptype="getVisualGroupType(field.key)"
                          :defaultRules="defaultRules ? defaultRules : rules"
                          :subform="true"
                          :multiple="true"
                          :id-prefix="`${getFieldId(field.key)}-${idx + 1}`"
                          @submit.prevent
                        />
                      </td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="removeArrayItem(field.key, idx)"
                        >
                          <i class="material-icons">close</i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-primary mt-2 px-3"
                @click="addArrayItem(field)"
              >
                {{ field.groupAddLineLabel ? $t(field.groupAddLineLabel) : '+' }}
              </button>
            </div>
            <!-- Campo list - Usando FieldList de model-definition-core -->
            <FieldList
              v-else-if="field.type === 'list' && field.listType"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :lists="lists"
              :record-item="formData"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo icon - Usando FieldIcon de model-definition-core -->
            <FieldIcon
              v-else-if="field.type === 'icon'"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :defaultIcons="defaultIcons"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo textlist: select con opciones personalizadas -->
            <!-- Campo textlist - Usando FieldTextList de model-definition-core -->
            <FieldTextList
              v-else-if="field.type === 'textlist' && !field.isArray"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :modelName="selectedModel"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Campo booleano -->
            <FormInput
              v-else-if="field.type === 'button' && !field.hide"
              :field="field"
              :formData="formData"
              :value="formData[field.key]"
              :fieldId="getFieldId(field.key)"
              @button-click="
                (val) => {
                  $emit('button-click', val);
                }
              "
              @input="(val) => onFieldChange(field.key, val)"
              :lock="field.safe && editingFields !== field.key"
            />

            <!-- Campo de archivo -->
            <!-- Campo file - Usando FieldFile de model-definition-core -->
            <FieldFile
              v-else-if="field.type === 'file'"
              :field="field"
              :value="formData[field.key]"
              mode="edit"
              :fieldId="getFieldId(field.key)"
              :editingFields="field.safe && editingFields !== field.key ? '' : field.key"
              :showLabel="false"
              @input="(val) => onFieldChange(field.key, val)"
              @update:editingFields="editingFields = $event"
            />

            <!-- Otros tipos pueden agregarse aquí -->
          </div>
        </div>
      </form>

      <ReferenceModal
        v-if="showReferenceModal && currentReferenceField"
        :is-visible="showReferenceModal"
        :model-name="currentReferenceField.ref"
        :model-label="currentReferenceField.label"
        :lists="lists"
        :models="models"
        :editing-item="currentEditingItem"
        @saved="handleReferenceSaved"
        @close="showReferenceModal = false"
        :parentID="formData._id"
        :selectedModel="selectedModel"
      />
    </div>
  </div>
</template>

<script>
import GroupIcon from "@/components/gotrading/common/GroupIcon.vue";
import { wencesApi } from "@/api/wencesApi";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { evaluate } from "mathjs";
import UploadFile from "./UploadFile.vue";
import ReferenceModal from "./ReferenceModal.vue";
import ruleEngineMixin from "@/mixins/ruleEngineMixin";
import permissionsMixin from "@/mixins/permissionsMixin";
import AutoIncrementField from "./AutoIncrementField.vue";
import FieldImage from "../fields/FieldImage.vue";
import {
  FieldText,
  FieldNumber,
  FieldList,
  FieldReference,
  FieldDate,
  FieldBoolean,
  FieldSelect,
  FieldTextList,
  FieldFile,
  FieldIcon,
} from "../model-definition-core";
import ContentSkeleton from "@/components/common/ContentSkeleton.vue";

export default {
  name: "Form2",
  mixins: [ruleEngineMixin, permissionsMixin],
  provide() {
    return { formContext: this };
  },
  props: {
    parentID: {
      type: [String, Object, Boolean, null],
      required: false,
      default: null,
    },
    visualGroups: {
      type: [Array, Object, Boolean, null],
      required: false,
      default: () => [],
    },
    fields: {
      type: [Array, Object, Boolean, null],
      required: false,
      default: () => [],
    },
    modelDefinitions: {
      type: [Object, Array, Boolean, null],
      required: false,
      default: () => {},
    },
    subform: { type: [Boolean, Object, Array, null], default: false },
    defaultRules: { type: [Array, Object, Boolean, null] },
    value: {
      type: [Object, Array, Boolean, null],
      required: false,
      default: () => ({}),
    },
    selectedModel: {
      type: [String, Object, Boolean, null],
      required: false,
      default: "",
    },
    lists: {
      type: [Array, Object, Boolean, null],
      required: false,
      default: () => [],
    },
    models: {
      type: [Array, Object, Boolean, null],
      required: false,
      default: () => [],
    },
    showButtons: { type: [Boolean, Object, Array, null], default: true },
    multiple: { type: [Boolean, Object, Array, null], default: false },
    visualgrouptype: {
      type: [String, Object, Boolean, null],
      default: "fieldset",
    },
    model: { type: [Object, Array, Boolean, null], required: false },
    idPrefix: { type: [String, Object, Boolean, null], default: "" },
    /** Acordeones de grupos visuales: chevrons Font Awesome en lugar de Material Icons. */
    useFontAwesomeGroupIcons: { type: Boolean, default: false },
    /** Tras cargar el formulario, dejar este grupo visual abierto (ej. `group_invoice`). */
    initialOpenVisualGroupKey: { type: String, default: "" },
  },
  data() {
    return {
      isSubmitting: false,
      isUploadingImage: false,
      internalFields: [],
      formData: {},
      open: false,
      referenceOptions: {},
      editingFields: "",
      rules: [],
      defaultIcons: [
        "home",
        "star",
        "favorite",
        "person",
        "settings",
        "check",
        "close",
        "info",
        "warning",
        "help",
        "dashboard",
        "event",
        "email",
        "phone",
        "lock",
        "search",
        "shopping_cart",
        "chat",
        "camera",
        "notifications",
        "location_on",
        "folder",
        "delete",
        "add",
        "arrow_forward",
        "arrow_back",
        "cloud",
        "battery_full",
        "schedule",
        "volume_up",
        "music_note",
        "brightness_7",
        "language",
        "fingerprint",
        "accessibility",
        "edit",
        "print",
        "map",
        "flash_on",
        "photo_camera",
        "assignment",
        "reorder",
        "delete_forever",
        "restore",
        "storage",
        "security",
        "account_circle",
        "call",
        "airplanemode_active",
        "directions",
        "explore",
        "poll",
        "today",
        "group",
        "show_chart",
        "touch_app",
        "developer_mode",
        "build",
        "location_searching",
        "camera_alt",
        "people",
        "stars",
        "swap_horiz",
        "swap_vert",
        "visibility",
        "play_arrow",
        "pause",
        "skip_next",
        "skip_previous",
        "stop",
        "settings_backup_restore",
        "access_alarm",
        "cloud_download",
        "cloud_upload",
        "alarm",
        "radio_button_checked",
        "radio_button_unchecked",
        "check_circle",
        "error",
        "message",
        "system_update",
        "add_circle",
        "remove_circle",
        "remove_circle_outline",
        "check_box",
        "indeterminate_check_box",
        "highlight_off",
        "save",
        "content_copy",
        "filter_list",
        "clear",
        "open_in_new",
        "file_copy",
        "more_vert",
        "more_horiz",
        "favorite_border",
        "flash_off",
        "battery_alert",
        "restore_from_trash",
        "tune",
        "undo",
        "redo",
        "phone_iphone",
        "tablet_android",
        "keyboard_arrow_up",
        "keyboard_arrow_down",
        "keyboard_arrow_left",
        "keyboard_arrow_right",
        "home_work",
        "business",
        "school",
        "event_note",
        "explore_off",
        "recent_actors",
        "apps",
        "alarm_add",
        "check_circle_outline",
        "check_box_outline_blank",
        "watch_later",
        "create",
        "keyboard",
        "mouse",
        "insert_emoticon",
        "autorenew",
      ],
      fieldDependencies: new Map(),
      showReferenceModal: false,
      currentReferenceField: null,
      currentEditingItem: null,
      isLoading: true,
      isDataReady: false,
      loadingPromises: [],
      searchingFields: new Set(), // Para trackear qué campos están buscando
      isProcessingRules: false, // Para evitar recursión en processRules
      isApplyingMapping: false, // Para prevenir bucle infinito en applyReverseMapping
      mappingInProgress: new Set(), // Para trackear campos específicos que están siendo mapeados
      mappingCache: new Map(), // Cache para evitar llamadas duplicadas al endpoint
      mappingDebounceTimers: new Map(), // Timers para debounce de mapeos
    };
  },
  watch: {
    value: {
      handler(newVal) {
        // Crear una copia del valor recibido
        const formDataCopy = { ...newVal };

        // Asegurarse de que los campos estén transformados
        this.transformFields();

        // Las fechas ahora se manejan como texto simple, no necesitan transformación
        this.internalFields.forEach((field) => {
          // Solo normalizar fechas si son objetos Date (legacy)
          if (
            field.type === "date" &&
            formDataCopy[field.key] instanceof Date
          ) {
            if (field.time) {
              // Para datetime: YYYY-MM-DDTHH:mm
              const year = formDataCopy[field.key].getFullYear();
              const month = String(
                formDataCopy[field.key].getMonth() + 1
              ).padStart(2, "0");
              const day = String(formDataCopy[field.key].getDate()).padStart(
                2,
                "0"
              );
              const hours = String(formDataCopy[field.key].getHours()).padStart(
                2,
                "0"
              );
              const minutes = String(
                formDataCopy[field.key].getMinutes()
              ).padStart(2, "0");
              formDataCopy[
                field.key
              ] = `${year}-${month}-${day}T${hours}:${minutes}`;
            } else {
              // Para fecha simple: YYYY-MM-DD
              formDataCopy[field.key] = formDataCopy[field.key]
                .toISOString()
                .split("T")[0];
            }
          }

          // Transformar campos de tipo list
          if (field.type === "list") {
            const list = this.lists?.find((l) => l.type === field.listType);
            if (list && list.values) {
              if (field.isArray && Array.isArray(formDataCopy[field.key])) {
                formDataCopy[field.key] = formDataCopy[field.key].map((id) => {
                  if (typeof id === "string") {
                    const option = list.values.find((opt) => opt._id === id);
                    return option || { _id: id, label: id };
                  }
                  return id;
                });
              } else if (formDataCopy[field.key]) {
                const id =
                  typeof formDataCopy[field.key] === "string"
                    ? formDataCopy[field.key]
                    : formDataCopy[field.key]._id;
                const option = list.values.find((opt) => opt._id === id);
                formDataCopy[field.key] = option || { _id: id, label: id };
              }
            }
          }

          // Transformar campos de tipo reference
          if (field.type === "reference" && field.ref) {
            if (field.isArray && Array.isArray(formDataCopy[field.key])) {
              formDataCopy[field.key] = formDataCopy[field.key].map((item) => {
                const id = item._id?._id || item._id;
                if (!id) return item;
                const option = this.referenceOptions[field.key]?.find(
                  (opt) => opt._id === id
                );
                return option || { _id: id, name: id };
              });
            } else if (formDataCopy[field.key]) {
              const id =
                formDataCopy[field.key]._id?._id || formDataCopy[field.key]._id;
              if (id) {
                const option = this.referenceOptions[field.key]?.find(
                  (opt) => opt._id === id
                );
                if (option) {
                  formDataCopy[field.key] = option;
                } else {
                  formDataCopy[field.key] = { _id: id, name: id };
                }
              }
            }
          }
        });

        this.formData = formDataCopy;
        this.ensureAllFields();
      },
      deep: true,
      immediate: true,
    },
    fields: {
      handler() {
        this.transformFields();
      },
      immediate: true,
    },
    selectedModel: {
      handler(newVal) {
        if (newVal) {
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$emit("input", this.formData);
  },
  mounted() {
    this.initializeForm();
    this.$nextTick(() => {
      this.applyVisualRules();
    });

    // Add event listeners for rule engine events
    this.$on("field-state-change", this.handleFieldStateChange);
    this.$on("field-value-change", this.handleFieldValueChange);
  },
  beforeDestroy() {
    // Remove event listeners
    this.$off("field-state-change", this.handleFieldStateChange);
    this.$off("field-value-change", this.handleFieldValueChange);

    // Limpiar timers de mapeo para evitar memory leaks
    this.mappingDebounceTimers.forEach((timer) => {
      if (timer) clearTimeout(timer);
    });
    this.mappingDebounceTimers.clear();
    this.mappingCache.clear();
    this.mappingInProgress.clear();
  },
  computed: {
    isArrayGroupField() {
      return this.idPrefix && /\d+$/.test(this.idPrefix);
    },
    visibleFields() {
      return this.internalFields.filter((field) => !field.hide);
    },
    filteredValues() {
      return (values) => {
        if (!values) return [];
        return values.filter((v) => v && (v._id || v.name || v.label));
      };
    },
    visibleGroupFields() {
      return (field) => {
        if (!field.fields) return [];
        return field.fields.filter((subField) => !subField.hide);
      };
    },
  },
  methods: {
    getState() {
      return this.formData || {};
    },
    setEditingField(fieldKey) {
      this.editingFields = fieldKey;
    },
    getClass() {
      return "p-2";
    },
    handleGroupInput(fieldKey, value) {
      this.formData[fieldKey] = value;

      if (!this.modelDefinitions) {
        this.$emit("input", this.formData);
        return;
      }

      const modeldef = this.modelDefinitions[this.selectedModel];
      
      if (!modeldef || !modeldef.fields) {
        this.$emit("input", this.formData);
        return;
      }

      if (
        typeof this.formData[fieldKey] === "object" &&
        this.formData[fieldKey] !== null
      ) {
        Object.keys(this.formData[fieldKey]).forEach((keygroup) => {
          const ModelDefField = modeldef.fields.find((f) => f.key === keygroup);
          if (!this.formData[fieldKey]) {
            this.formData[fieldKey] = [];
          }
          if (
            ModelDefField !== undefined &&
            ModelDefField.isArray &&
            this.formData[fieldKey] &&
            this.formData[fieldKey][keygroup] &&
            typeof this.formData[fieldKey][keygroup] === "object" &&
            this.formData[fieldKey][keygroup] !== null
          ) {
            Object.keys(this.formData[fieldKey][keygroup]).forEach((key) => {
              // Validar que keygroup existe en formData y no es null antes de acceder
              if (!this.formData[keygroup]) {
                // Inicializar keygroup si no existe
                this.$set(this.formData, keygroup, {});
              }
              
              // Validar que el item existe antes de acceder a sus propiedades
              if (!this.formData[keygroup][key]) {
                this.$set(this.formData[keygroup], key, {});
              }
              
              // Validar que el item en fieldKey[keygroup][key] existe
              if (
                !this.formData[fieldKey] ||
                !this.formData[fieldKey][keygroup] ||
                !this.formData[fieldKey][keygroup][key]
              ) {
                // Inicializar la estructura si no existe
                if (!this.formData[fieldKey][keygroup][key]) {
                  this.$set(this.formData[fieldKey][keygroup], key, {});
                }
              }

              // Validar que ModelDefField.fields existe antes de iterar
              if (ModelDefField.fields && Array.isArray(ModelDefField.fields)) {
                ModelDefField.fields.forEach((field) => {
                  // Validar que this.formData[keygroup][key] existe y es un objeto
                  if (
                    this.formData[keygroup] &&
                    this.formData[keygroup][key] &&
                    typeof this.formData[keygroup][key] === "object" &&
                    this.formData[keygroup][key][field.key] === undefined
                  ) {
                    this.$set(this.formData[keygroup][key], field.key, null);
                  }
                  
                  // Validar que this.formData[fieldKey][keygroup][key] existe y es un objeto
                  if (
                    this.formData[fieldKey] &&
                    this.formData[fieldKey][keygroup] &&
                    this.formData[fieldKey][keygroup][key] &&
                    typeof this.formData[fieldKey][keygroup][key] === "object" &&
                    this.formData[fieldKey][keygroup][key][field.key] === undefined
                  ) {
                    this.$set(
                      this.formData[fieldKey][keygroup][key],
                      field.key,
                      null
                    );
                  }
                });
              }
            });

            // Solo asignar si keygroup existe y es válido
            if (this.formData[fieldKey] && this.formData[fieldKey][keygroup]) {
              this.$set(this.formData, keygroup, this.formData[fieldKey][keygroup]);
            }
          }
        });
      }

      this.$emit("input", this.formData);
    },
    getVisualRules() {
      let model = this.models.filter(
        (m) => m.modelName === this.selectedModel
      )[0];
      if (!model) {
        return [];
      }
      return model.visualRules;
    },
    async initializeForm() {
      try {
        this.isLoading = true;
        this.isDataReady = false;
        this.loadingPromises = [];

        // Cargar todas las opciones de referencia
        const referencePromise = this.loadAllReferenceOptions();
        this.loadingPromises.push(referencePromise);

        // Transformar los campos
        this.transformFields();

        // Si hay un modelo seleccionado, cargar las reglas
        if (this.selectedModel) {
          const rulesPromise = this.loadRules();
          this.loadingPromises.push(rulesPromise);
        } else {
        }

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(this.loadingPromises);

        // Agregar listener para el evento field-updated
        document.addEventListener("field-updated", (event) => {
          const { fieldId, value } = event.detail;

          // Actualizar el valor en formData
          this.$set(this.formData, fieldId, value);
          // Emitir el cambio al componente padre
          this.$emit("input", this.formData);
        });

        // Marcar como listo solo cuando todo esté cargado
        this.isDataReady = true;

        const openKey =
          this.initialOpenVisualGroupKey &&
          String(this.initialOpenVisualGroupKey).trim();
        if (openKey) {
          this.open = openKey;
        }

        // Asegurar que las reglas se ejecuten después de que el formulario esté listo
        this.$nextTick(() => {
          // Verificar que no estemos en un ciclo de recursión
          if (!this.isProcessingRules) {
            this.isProcessingRules = true;
            this.processRules();
            this.applyVisualRules();
            this.$nextTick(() => {
              this.isProcessingRules = false;
            });
          }
        });
      } catch (error) {
        console.error("❌ [INIT] Error initializing form:", error);
      } finally {
        this.isLoading = false;
      }
    },
    isSubGroup(field) {
      return this.subform && field.type == "group" && field.isArray;
    },
    getMultiselectLabel(option) {
      if (!option) return "No name";

      // Si es un objeto con name, usar name
      if (option.name) {
        return option.name;
      }

      // Si es un objeto con label, usar label
      if (option.label) {
        return option.label;
      }

      // Si es un objeto con _id que es un objeto, intentar obtener name o label
      if (option._id && typeof option._id === "object") {
        return option._id.name || option._id.label || "No name";
      }

      // Si es un string o número, usarlo directamente
      if (typeof option === "string" || typeof option === "number") {
        return String(option);
      }

      // Si tiene _id, usar _id
      if (option._id) {
        return String(option._id);
      }

      // Si no hay nada más, devolver 'Sin nombre'
      return "No name";
    },
    getClassFieldset(field) {
      if (
        this.subform &&
        this.visualgrouptype === "fieldset" &&
        this.fields.length > 1 &&
        field.type == "group"
      ) {
        return "  border-bottom p-1  m-0  mb-1";
      }

      if (this.subform) {
        return " border-bottom py-2 ";
      }

      if (this.open === field.key) {
        return (
          "bg-primary text-white border p-2 mb-0 border-primary " +
          this.selectedModel.toLowerCase()
        );
      } else {
        return "border p-2  ";
      }
    },
    getBoxClass(fieldKey) {
      if (
        this.open !== fieldKey &&
        this.getVisualGroupType(fieldKey) === "fieldset"
      ) {
        return "d-none";
      }
      if (this.getVisualGroupType(fieldKey) === "box") {
        return "";
      }
      return (
        " border-primary border " + this.selectedModel.toLowerCase()
      );
    },
    formWidthColClass(field) {
      const w = Number(field && field.formWidth);
      if (w === 100) return "col-12";
      if (w === 50) return "col-12 col-md-6";
      if (w === 25) return "col-12 col-sm-6 col-lg-3";
      return null;
    },
    getContainerClass(field) {
      let result = "";
      // Un grupo múltiple se dibuja como tabla y puede ser más ancho que el
      // formulario: el contenedor acompaña ese ancho para que el título no
      // quede cortado a la mitad de la tabla. Aplica también a los grupos
      // anidados, que se renderizan en modo `multiple` dentro de un <td>.
      const wide =
        field.isArray && field.type === "group" ? " group-multiple-field" : "";
      if (this.multiple) {
        return " flex-column " + field.key + " " + field.type + wide;
      }
      // Los anchos por defecto son los mismos que en el formulario normal
      // (Form.vue): el popup no debe maquetar distinto que la pantalla.
      const fw = this.formWidthColClass(field);
      if (this.getVisualGroupType(field.key) === "box") {
        result += fw ? " " + fw + " my-3 " : " col-12 my-3 ";
      } else if (!this.subform && field.type == "group") {
        result += fw ? " " + fw + " m-0 p-0" : " col-12 m-0 p-0";
      } else if (this.subform && this.visualgrouptype === "fieldset") {
        if (this.fields.length > 1 && field.type == "group") {
          result += fw ? fw + " p-2 field-" + field.key : "";
        } else {
          result += fw
            ? fw + " p-2 field-" + field.key
            : "col-12 col-md-6 p-2 field-" + field.key;
        }
      } else if (!this.multiple) {
        result += fw
          ? fw + " p-2 mb-2 field-" + field.key
          : "col-12 col-md-6 col-lg-3 p-2 mb-2 field-" + field.key;
      }
      return result + wide;
    },
    ensureAllFields() {
      // Determinar si es un nuevo contenido (sin _id) o se está editando
      const isNewContent = !this.formData._id;
      this.internalFields.forEach((field) => {
        if (
          !this.formData[field.key] ||
          this.formData[field.key] === undefined ||
          this.formData[field.key] === 0 ||
          this.formData[field.key] === null ||
          (Array.isArray(this.formData[field.key]) &&
            this.formData[field.key].length === 0)
        ) {
          if (field.isArray) {
            if (isNewContent && field.defaultValue !== undefined) {
              this.$set(this.formData, field.key, field.defaultValue);
            } else {
              this.$set(this.formData, field.key, []);
            }
          } else if (field.type === "array") {
            this.$set(this.formData, field.key, []);
          } else if (field.type === "group") {
            this.$set(this.formData, field.key, {});
          } else if (field.type === "boolean") {
            // Asegurarnos de que el valor booleano sea estrictamente true o false
            if (this.formData[field.key] == undefined) {
              this.$set(
                this.formData,
                field.key,
                field.defaultValue === "true" ? true : false
              );
            } else {
              this.$set(
                this.formData,
                field.key,
                this.formData[field.key] === true
              );
            }
          } else {
            // Solo asignar defaultValue si es un nuevo contenido y el campo tiene defaultValue definido
            if (isNewContent && field.defaultValue !== undefined) {
              // Para campos list, convertir el defaultValue (ID) al objeto completo
              if (
                field.type === "list" &&
                typeof field.defaultValue === "string"
              ) {
                const list = this.lists?.find((l) => l.type === field.listType);
                if (list && list.values) {
                  const option = list.values.find(
                    (opt) => opt._id === field.defaultValue
                  );
                  if (option) {
                    this.$set(this.formData, field.key, option);
                  } else {
                    this.$set(this.formData, field.key, field.defaultValue);
                  }
                } else {
                  this.$set(this.formData, field.key, field.defaultValue);
                }
              } else if (
                field.type === "reference" &&
                typeof field.defaultValue === "string" &&
                field.defaultValue.trim() !== ""
              ) {
                // Para campos reference, cargar el valor por defecto de forma asíncrona
                // Solo si no hay un valor ya establecido
                if (!this.formData[field.key] || !this.formData[field.key]._id) {
                  // Se establecerá un placeholder temporal y luego se cargará el objeto completo
                  this.$set(this.formData, field.key, { _id: field.defaultValue, name: 'Cargando...' });
                  // Cargar el valor por defecto de forma asíncrona
                  this.loadDefaultReferenceValue(field);
                }
              } else {
                this.$set(this.formData, field.key, field.defaultValue);
              }
            } else {
              this.$set(this.formData, field.key, "");
            }
          }
        } else if (field.type === "boolean") {
          // Convertir cualquier valor a booleano estricto
          if (this.formData[field.key] == undefined) {
            this.$set(
              this.formData,
              field.key,
              field.defaultValue === "true" ? true : false
            );
          } else {
            this.$set(
              this.formData,
              field.key,
              this.formData[field.key] === true
            );
          }
        } else if (field.isArray && Array.isArray(this.formData[field.key])) {
          // Limpiar arrays que contengan valores nulos
          const cleanArray = this.formData[field.key].filter(
            (item) => item !== null
          );
          this.$set(this.formData, field.key, cleanArray);
        }
      });
    },

    // Función recursiva para encontrar campos de tipo reference
    async findReferenceFields(fields, formData) {
      for (const field of fields) {
        if (field.fields && field.fields.length > 0) {
          for (const subfield of field.fields) {
            for (const formadatakey of Object.keys(formData)) {
              if (formadatakey === subfield.key) {
                if (subfield.type === "reference") {
                  // Si tenemos un ID, hacer una llamada a la API para obtener el objeto completo
                  if (
                    !Object.is(formData[formadatakey]) &&
                    formData[formadatakey]._id
                  ) {
                    try {
                      const { data } = await wencesApi.get(
                        `/api/gotrading/dynamic/${subfield.ref}/${formData[formadatakey]._id}`
                      );
                      if (data) {
                        formData[formadatakey] = data;
                      }
                    } catch (error) {
                      console.error("Error fetching reference data:", error);
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    async onFieldChange(fieldKey, value, index) {
      // Encontrar la definición del campo
      const field = this.fields.find((f) => f.key === fieldKey);
      if (!field) {
        console.warn("Field not found:", fieldKey);
        return;
      }

      // Asegurarse de que el valor sea válido antes de actualizar
      let processedValue = value;

      if (value === null || value === undefined) {
        processedValue = this.fields.find((f) => f.key === fieldKey)?.isArray
          ? []
          : null;
      } else if (Array.isArray(value)) {
        if (field.type === "group" || field.type === "image") {
          // Para grupos e imágenes, mantener el valor tal cual
          processedValue = value;
        } else {
          processedValue = value.filter(
            (v) => v && (typeof v === "string" || v._id || v.name || v.label)
          );
        }
      } else if (typeof value === "object") {
        if (!value._id && !value.name && !value.label) {
          processedValue = null;
        }
      }

      // Actualizar el valor en formData
      if (index !== undefined && index !== null) {
        this.$set(this.formData[fieldKey], index, processedValue);
      } else {
        this.$set(this.formData, fieldKey, processedValue);
      }

      // Emitir el cambio al componente padre
      this.$emit("input", this.formData);

      // Aplicar reglas visuales después de cada cambio
      this.applyVisualRules();

      // Ejecutar las reglas del motor de reglas
      this.$nextTick(() => {
        // Verificar que no estemos en un ciclo de recursión
        if (!this.isProcessingRules) {
          this.isProcessingRules = true;
          this.processRules();
          this.$nextTick(() => {
            this.isProcessingRules = false;
          });
        }
      });
    },

    // Método para actualizar automáticamente el campo de fecha cuando se genera un autoincrement
    updateDateField({ fieldKey, value }) {
      try {
        // Actualizar el valor en formData
        this.$set(this.formData, fieldKey, value);

        // Emitir el cambio al componente padre
        this.$emit("input", this.formData);
      } catch (error) {
        console.error("Error updating date field:", error);
      }
    },

    onInvoiceNumberPreview(isPreview) {
      if (!this.formData) return;
      if (isPreview) {
        this.$set(this.formData, "_invoiceNumberPreview", true);
      } else {
        this.$delete(this.formData, "_invoiceNumberPreview");
      }
      this.$emit("input", this.formData);
    },

    addArrayItem(field) {
      // Asegurarse de que el array existe
      if (!this.formData[field.key]) {
        this.$set(this.formData, field.key, []);
      }

      // Crear un nuevo elemento según el tipo de campo
      let newItem;
      if (
        field.type === "group" ||
        (field.itemFields && field.itemFields.length > 0)
      ) {
        // Si es un grupo o tiene itemFields, crear un objeto con la estructura correcta
        newItem = {};
        const fieldsToProcess = field.itemFields || field.fields || [];

        fieldsToProcess.forEach((subField) => {
          if (subField.isArray) {
            newItem[subField.key] = [];
          } else if (subField.type === "group") {
            newItem[subField.key] = {};
          } else if (subField.type === "boolean") {
            newItem[subField.key] = false;
          } else if (subField.type === "number") {
            newItem[subField.key] =
              subField.defaultValue !== undefined ? subField.defaultValue : 0;
          } else if (subField.type === "date" && !subField.time) {
            newItem[subField.key] =
              subField.defaultValue !== undefined
                ? subField.defaultValue
                : new Date().toISOString().split("T")[0];
          } else if (subField.type === "date" && subField.time) {
            // Para campos datetime, usar métodos locales que preserven la hora
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            newItem[subField.key] =
              subField.defaultValue !== undefined
                ? subField.defaultValue
                : `${year}-${month}-${day}T${hours}:${minutes}`;
          } else if (subField.type === "list") {
            // Para campos list, buscar el defaultValue si está definido
            if (subField.defaultValue && typeof subField.defaultValue === "string") {
              const list = this.lists?.find((l) => l.type === subField.listType);
              if (list && list.values) {
                const option = list.values.find(
                  (opt) => opt._id === subField.defaultValue
                );
                if (option) {
                  newItem[subField.key] = option;
                } else {
                  newItem[subField.key] = { _id: "", name: "" };
                }
              } else {
                newItem[subField.key] = { _id: "", name: "" };
              }
            } else {
              newItem[subField.key] = { _id: "", name: "" };
            }
          } else if (subField.type === "reference") {
            // Para campos reference, buscar el defaultValue si está definido y no está vacío
            if (subField.defaultValue && typeof subField.defaultValue === "string" && subField.defaultValue.trim() !== "") {
              newItem[subField.key] = { _id: subField.defaultValue, name: 'Cargando...' };
            } else {
              newItem[subField.key] = { _id: "", name: "" };
            }
          } else {
            newItem[subField.key] =
              subField.defaultValue !== undefined ? subField.defaultValue : "";
          }
        });
      } else {
        // Para campos simples
        switch (field.type) {
          case "string":
            newItem =
              field.defaultValue !== undefined ? field.defaultValue : "";
            break;
          case "number":
            newItem = field.defaultValue !== undefined ? field.defaultValue : 0;
            break;
          case "boolean":
            newItem =
              field.defaultValue !== undefined ? field.defaultValue : false;
            break;
          case "date":
            if (field.time) {
              // Para campos datetime, usar métodos locales que preserven la hora
              const now = new Date();
              const year = now.getFullYear();
              const month = String(now.getMonth() + 1).padStart(2, "0");
              const day = String(now.getDate()).padStart(2, "0");
              const hours = String(now.getHours()).padStart(2, "0");
              const minutes = String(now.getMinutes()).padStart(2, "0");
              newItem =
                field.defaultValue !== undefined
                  ? field.defaultValue
                  : `${year}-${month}-${day}T${hours}:${minutes}`;
            } else {
              newItem =
                field.defaultValue !== undefined
                  ? field.defaultValue
                  : new Date().toISOString().split("T")[0];
            }
            break;
          case "reference":
            // Para campos reference, buscar el defaultValue si está definido y no está vacío
            if (field.defaultValue && typeof field.defaultValue === "string" && field.defaultValue.trim() !== "") {
              newItem = { _id: field.defaultValue, name: 'Cargando...' };
              this.loadReferenceValueForArrayItem(field, this.formData[field.key].length);
            } else {
              newItem = { _id: "", name: "" };
            }
            break;
          case "list":
            // Para campos list, buscar el defaultValue si está definido
            if (field.defaultValue && typeof field.defaultValue === "string") {
              const list = this.lists?.find((l) => l.type === field.listType);
              if (list && list.values) {
                const option = list.values.find(
                  (opt) => opt._id === field.defaultValue
                );
                if (option) {
                  newItem = option;
                } else {
                  newItem = { _id: "", name: "" };
                }
              } else {
                newItem = { _id: "", name: "" };
              }
            } else {
              newItem = { _id: "", name: "" };
            }
            break;
          case "textlist":
            newItem =
              field.defaultValue !== undefined ? field.defaultValue : "";
            break;
          case "email":
            newItem =
              field.defaultValue !== undefined ? field.defaultValue : "";
            break;
          default:
            newItem =
              field.defaultValue !== undefined ? field.defaultValue : "";
        }
      }

      // Agregar el nuevo item al array
      this.formData[field.key].push(newItem);

      // Forzar la actualización del array
      this.$set(this.formData, field.key, [...this.formData[field.key]]);

      // Emitir el cambio al componente padre
      this.$emit("input", this.formData);
    },
    async removeArrayItem(fieldKey, idx) {
      const formData = { ...this.formData };
      this.formData[fieldKey] = null;
      formData[fieldKey].splice(idx, 1);
      this.formData = formData;

      this.$emit("input", this.formData);
    },
    async onImageChange(event, key) {
      const file = event.target.files[0];
      if (file) {
        // Validar tamaño (5MB máximo)
        if (file.size > 5 * 1024 * 1024) {
          this.$swal?.fire?.({
            title: "Error",
            text: "El archivo es demasiado grande. El tamaño máximo permitido es 5MB.",
            icon: "error",
          });
          event.target.value = "";
          return;
        }

        // Validar tipo de archivo
        if (!file.type.startsWith("image/")) {
          this.$swal?.fire?.({
            title: "Error",
            text: "Por favor, selecciona un archivo de imagen válido.",
            icon: "error",
          });
          event.target.value = "";
          return;
        }

        // Mostrar preview temporal mientras sube
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$set(this.formData, key, e.target.result);
        };
        reader.readAsDataURL(file);

        // Subir a S3 inmediatamente
        this.isUploadingImage = true;
        const uploadResult = await this.uploadImageToS3(file);
        this.isUploadingImage = false;

        if (uploadResult.ok) {
          this.$set(this.formData, key, uploadResult.url);
          this.$emit("input", this.formData);
        } else {
          this.$swal?.fire?.({
            title: "Error",
            text: uploadResult.message || "Error al subir la imagen",
            icon: "error",
          });
          // Limpiar el campo si falló la subida
          this.$set(this.formData, key, null);
          event.target.value = "";
        }
      }
    },
    async uploadImageToS3(file) {
      const formDataUpload = new FormData();
      formDataUpload.append('image', file);

      try {
        const response = await wencesApi.post('/api/upload/upload-public', formDataUpload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return { ok: true, url: response.data.url };
      } catch (error) {
        console.error('Error uploading image:', error);
        return { ok: false, message: error.response?.data?.message || 'Error al subir la imagen' };
      }
    },
    // Métodos para manejar archivos de FieldImage - Form2 sube inmediatamente
    async handlePendingImageFile(key, file) {
      if (!file) {
        return;
      }
      this.isUploadingImage = true;
      const uploadResult = await this.uploadImageToS3(file);
      this.isUploadingImage = false;

      if (uploadResult.ok) {
        this.$set(this.formData, key, uploadResult.url);
        this.$emit("input", this.formData);
      } else {
        this.$swal?.fire?.({
          title: "Error",
          text: uploadResult.message || "Error al subir la imagen",
          icon: "error",
        });
        this.$set(this.formData, key, null);
      }
    },
    async handlePendingImageFiles(key, files) {
      if (!files || !files.length) return;

      this.isUploadingImage = true;
      const currentValue = this.formData[key];
      const existingUrls = Array.isArray(currentValue)
        ? currentValue.filter((url) => typeof url === "string" && !url.startsWith("data:"))
        : [];
      const uploadedUrls = [...existingUrls];

      for (const file of files) {
        const uploadResult = await this.uploadImageToS3(file);
        if (uploadResult.ok) {
          uploadedUrls.push(uploadResult.url);
        } else {
          this.$swal?.fire?.({
            title: "Error",
            text: uploadResult.message || `Error al subir "${file.name}"`,
            icon: "error",
          });
        }
      }

      this.$set(this.formData, key, uploadedUrls);
      this.$emit("input", this.formData);
      this.isUploadingImage = false;
    },
    handleRemovePendingImageFile(key, index) {
      // En Form2 no hay archivos pendientes, las imágenes ya están subidas
      // Solo necesitamos actualizar el array de URLs
      const currentValue = this.formData[key];
      if (Array.isArray(currentValue)) {
        const newArray = [...currentValue];
        newArray.splice(index, 1);
        this.$set(this.formData, key, newArray);
        this.$emit("input", this.formData);
      }
    },

    getListOptions(field) {
      const list = this.lists?.find((l) => l.type === field.listType);
      return list ? list.values : [];
    },

    getAllFields(fields) {
      let all = [];
      fields.forEach((field) => {
        all.push(field);
        if (field.fields && Array.isArray(field.fields)) {
          all = all.concat(this.getAllFields(field.fields));
        }
        if (field.itemFields && Array.isArray(field.itemFields)) {
          all = all.concat(this.getAllFields(field.itemFields));
        }
      });
      return all;
    },
    async loadAllReferenceOptions() {
      // Inicializar arrays vacíos para los campos de referencia
      for (const field of this.internalFields) {
        if (field.type === "reference" && field.ref) {
          this.$set(this.referenceOptions, field.key, []);

          // Si hay un valor inicial, cargarlo individualmente
          if (this.formData[field.key]) {
            await this.loadInitialReferenceValue(field);
          }
          // Si hay un defaultValue pero no hay valor en formData, cargarlo (solo si no está vacío)
          else if (field.defaultValue && typeof field.defaultValue === "string" && field.defaultValue.trim() !== "") {
            await this.loadDefaultReferenceValue(field);
          }
        }
      }
    },

    async loadInitialReferenceValue(field) {
      try {
        if (field.isArray && Array.isArray(this.formData[field.key])) {
          // Si es un array de IDs, cargar cada uno individualmente
          const mappedValues = [];
          const initialOptions = [];

          for (const id of this.formData[field.key]) {
            if (!id) continue;
            const idValue = typeof id === "string" ? id : id._id || id;
            if (!idValue) continue;

            // Buscar el item específico
            const { data } = await wencesApi.get(
              `/api/gotrading/dynamic/${field.ref}/${idValue}`
            );
            if (data) {
              mappedValues.push(data);
              initialOptions.push(data); // Agregar a las opciones iniciales
            } else {
              const fallbackItem = { _id: idValue, name: idValue };
              mappedValues.push(fallbackItem);
              initialOptions.push(fallbackItem); // Agregar a las opciones iniciales
            }
          }

          this.$set(this.formData, field.key, mappedValues);
          this.$set(this.referenceOptions, field.key, initialOptions); // Establecer las opciones iniciales
        } else if (this.formData[field.key]) {
          const id =
            typeof this.formData[field.key] === "string"
              ? this.formData[field.key]
              : this.formData[field.key]._id || this.formData[field.key];

          if (id) {
            // Buscar el item específico
            const { data } = await wencesApi.get(
              `/api/gotrading/dynamic/${field.ref}/${id}`
            );
            if (data) {
              this.$set(this.formData, field.key, data);
              this.$set(this.referenceOptions, field.key, [data]); // Establecer las opciones iniciales
            } else {
              const fallbackItem = { _id: id, name: id };
              this.$set(this.formData, field.key, fallbackItem);
              this.$set(this.referenceOptions, field.key, [fallbackItem]); // Establecer las opciones iniciales
            }
          }
        }
      } catch (error) {
        console.error(
          `Error loading initial reference value for ${field.key}:`,
          error
        );
      }
    },

    async loadDefaultReferenceValue(field) {
      try {
        if (!field.defaultValue || !field.ref || (typeof field.defaultValue === "string" && field.defaultValue.trim() === "")) return;
        
        // Verificar si ya hay un valor establecido (y no es solo el placeholder)
        const currentValue = this.formData[field.key];
        if (currentValue && currentValue._id && currentValue._id !== field.defaultValue) {
          // Ya hay un valor diferente, no sobrescribir
          return;
        }
        
        // Si el valor actual es el placeholder "Cargando...", continuar con la carga
        if (currentValue && currentValue._id === field.defaultValue && currentValue.name === 'Cargando...') {
          // Continuar con la carga
        } else if (currentValue && currentValue._id === field.defaultValue && currentValue.name && currentValue.name !== 'Cargando...') {
          // Ya está cargado correctamente, solo asegurar que esté en referenceOptions
          if (!this.referenceOptions[field.key] || !this.referenceOptions[field.key].some(opt => opt._id === currentValue._id)) {
            this.$set(this.referenceOptions, field.key, [currentValue]);
          }
          return;
        }
        
        const id = field.defaultValue;
        const { data } = await wencesApi.get(
          `/api/gotrading/dynamic/${field.ref}/${id}`
        );
        
        if (data) {
          this.$set(this.formData, field.key, data);
          // Asegurar que referenceOptions esté inicializado
          if (!this.referenceOptions[field.key]) {
            this.$set(this.referenceOptions, field.key, []);
          }
          // Agregar a referenceOptions si no existe
          if (!this.referenceOptions[field.key].some(opt => opt._id === data._id)) {
            this.referenceOptions[field.key].push(data);
            this.$set(this.referenceOptions, field.key, [...this.referenceOptions[field.key]]);
          }
        } else {
          const fallbackItem = { _id: id, name: id };
          this.$set(this.formData, field.key, fallbackItem);
          // Asegurar que referenceOptions esté inicializado
          if (!this.referenceOptions[field.key]) {
            this.$set(this.referenceOptions, field.key, []);
          }
          // Agregar a referenceOptions si no existe
          if (!this.referenceOptions[field.key].some(opt => opt._id === fallbackItem._id)) {
            this.referenceOptions[field.key].push(fallbackItem);
            this.$set(this.referenceOptions, field.key, [...this.referenceOptions[field.key]]);
          }
        }
      } catch (error) {
        console.error(
          `Error loading default reference value for ${field.key}:`,
          error
        );
        const fallbackItem = { _id: field.defaultValue, name: field.defaultValue };
        this.$set(this.formData, field.key, fallbackItem);
        // Asegurar que referenceOptions esté inicializado incluso en caso de error
        if (!this.referenceOptions[field.key]) {
          this.$set(this.referenceOptions, field.key, []);
        }
        if (!this.referenceOptions[field.key].some(opt => opt._id === fallbackItem._id)) {
          this.referenceOptions[field.key].push(fallbackItem);
          this.$set(this.referenceOptions, field.key, [...this.referenceOptions[field.key]]);
        }
      }
    },

    async loadReferenceValueForArrayItem(field, index) {
      try {
        if (!field.defaultValue || !field.ref || (typeof field.defaultValue === "string" && field.defaultValue.trim() === "")) return;
        
        const id = field.defaultValue;
        const { data } = await wencesApi.get(
          `/api/gotrading/dynamic/${field.ref}/${id}`
        );
        
        if (data && this.formData[field.key] && this.formData[field.key][index]) {
          this.$set(this.formData[field.key], index, data);
        }
      } catch (error) {
        console.error(
          `Error loading reference value for array item ${field.key}[${index}]:`,
          error
        );
      }
    },

    async loadRules() {
      if (this.selectedModel) {
        try {
          if (this.defaultRules) {
            this.rules = this.defaultRules;
          } else {
            const { data } = await wencesApi.get(
              `/api/gotrading/rules/${this.selectedModel}`
            );
            this.rules = data;
          }

          // Agregar las reglas al motor
          if (this.rules && this.rules.length > 0) {
            this.rules.forEach((r, index) => {
              this.addRule({
                pattern: r.action,
                destination: r.targetField,
                condition: r.condition,
                validationMessage: r.validationMessage || "",
              });
            });

            // Ejecutar las reglas inmediatamente después de cargarlas
            this.$nextTick(() => {
              // Verificar que no estemos en un ciclo de recursión
              if (!this.isProcessingRules) {
                this.isProcessingRules = true;
                this.processRules();
                this.applyVisualRules();
                this.$nextTick(() => {
                  this.isProcessingRules = false;
                });
              }
            });
          } else {
          }
        } catch (error) {
          console.error("❌ [RULES] Error loading rules:", error);
          this.rules = [];
        }
      }
    },
    updateGroupArray(fieldKey, index, value) {
      // Asegurarse de que el array existe
      if (!this.formData[fieldKey]) {
        this.$set(this.formData, fieldKey, []);
      }

      // Si el valor es un Observer, obtener su valor real
      const realValue = value && value.__ob__ ? { ...value } : value;

      // Si el valor es un objeto, hacer una copia profunda
      const processedValue =
        typeof realValue === "object" && realValue !== null
          ? JSON.parse(JSON.stringify(realValue))
          : realValue;

      // Actualizar el elemento específico del array
      this.$set(this.formData[fieldKey], index, processedValue);

      // Forzar la actualización del array completo
      this.$set(this.formData, fieldKey, [...this.formData[fieldKey]]);

      // Emitir el cambio al componente padre
      if (!this.subform) {
        this.$emit("input", this.formData);
      }
    },
    transformFields() {
      // Campos internos del sistema que nunca deben ser editables en formularios
      const systemFields = [
        '_id',
        'createdAt',
        'updatedAt',
        'createdBy',
        'updatedBy',
        'editHistory',
        '__v',
        'textPlainVersion',
        'idModel'
      ];
      
      // Función para filtrar campos del sistema
      const filterSystemFields = (fields) => {
        if (!fields || !Array.isArray(fields)) return [];
        return fields.filter(field => !systemFields.includes(field.key));
      };
      
      // Filtrar campos del sistema del array principal
      const filteredFields = filterSystemFields(this.fields);
      
      if (filteredFields && this.visualGroups.length > 0) {
        // Crear un mapa de campos por grupo visual
        const fieldsByGroup = new Map();
        this.visualGroups.forEach((group) => {
          fieldsByGroup.set(group.name, {
            key: `group_${group.name}`,
            label: group.label,
            type: "group",
            icon: group.icon,
            description: group.description, // Agregar la descripción del grupo
            fields: [],
          });
        });

        // Mantener el orden original de los campos
        this.internalFields = filteredFields
          .map((field) => {
            if (field.visualGroup && fieldsByGroup.has(field.visualGroup)) {
              // Si el campo pertenece a un grupo visual, agregarlo al grupo
              const group = fieldsByGroup.get(field.visualGroup);
              group.fields.push(field);
              // Si es el primer campo del grupo, insertar el grupo en esta posición
              if (group.fields.length === 1) {
                return group;
              }
              return null; // No incluir el campo directamente
            }
            return field; // Mantener campos sin grupo visual
          })
          .filter(Boolean); // Eliminar los null
      } else {
        // Si no hay grupos visuales, usar los campos filtrados
        this.internalFields = [...filteredFields];
      }
    },
    getReferenceId(fieldKey) {
      const value = this.formData[fieldKey];
      if (!value) return "";
      // Si es un objeto con _id, devolver el _id
      if (typeof value === "object" && value._id) {
        return value._id;
      }
      // Si ya es un string (el _id), devolverlo directamente
      return value;
    },
    extractFieldsFromExpression(expression) {
      const fields = new Set();
      const regex = /([a-zA-Z0-9_]+(?:\.[a-zA-Z0-9_]+)*)/g;
      let match;

      while ((match = regex.exec(expression)) !== null) {
        // Ignorar operadores y valores literales
        if (
          !["true", "false", "null", "undefined"].includes(match[1]) &&
          !["+", "-", "*", "/", "===", "!==", ">", "<", ">=", "<="].includes(
            match[1]
          )
        ) {
          fields.add(match[1]);
        }
      }

      return Array.from(fields);
    },

    getVisualGroupType(groupKey) {
      // Extraer el nombre del grupo del key (group_nombreGrupo)
      const groupName = groupKey.replace("group_", "");
      // Buscar el grupo en visualGroups
      const group = this.visualGroups?.find((g) => g.name === groupName);
      return group?.type || ""; // Por defecto fieldset si no se encuentra
    },
    // Verificar si el usuario puede editar un grupo visual (para formularios)
    canEditVisualGroup(field) {
      // Si no es un grupo, permitir
      if (field.type !== 'group') {
        return true;
      }
      
      // Extraer el nombre del grupo del key
      const groupName = field.key.replace("group_", "");
      const group = this.visualGroups?.find((g) => g.name === groupName);
      
      // Si no se encuentra el grupo, permitir por defecto
      if (!group) {
        return true;
      }
      
      // Si no hay restricciones, permitir por defecto
      if (!group.roleRestrictions || group.roleRestrictions.length === 0) {
        return true;
      }
      
      const userRole = localStorage.getItem("role");
      if (!userRole) {
        return false;
      }
      
      // Si es admin, puede editar todo
      if (userRole === "admin") {
        return true;
      }
      
      // Buscar restricción para el rol del usuario
      const restriction = group.roleRestrictions.find(r => r.roleName === userRole);
      if (!restriction) {
        // Si no hay restricción específica, permitir por defecto
        return true;
      }
      
      return restriction.canEdit !== false; // Por defecto true si no está definido
    },
    getFieldId(fieldKey) {
      if (this.idPrefix) {
        return `${this.idPrefix}-${fieldKey}`;
      }
      return fieldKey;
    },
    async openReferenceModal(field, editingItem) {
      try {
        this.currentReferenceField = {
          ...field,
        };
        this.currentEditingItem = editingItem;
        this.showReferenceModal = true;
      } catch (error) {
        console.error("Error loading model definition:", error);
      }
    },
    handleReferenceSaved(savedItem) {
      if (this.currentReferenceField && this.currentReferenceField.ref) {
        // Actualizar las opciones de referencia
        const index = this.referenceOptions[
          this.currentReferenceField.key
        ].findIndex((item) => item._id === savedItem._id);
        if (index !== -1) {
          this.$set(
            this.referenceOptions[this.currentReferenceField.key],
            index,
            savedItem
          );
        } else {
          this.referenceOptions[this.currentReferenceField.key].push(savedItem);
        }

        // Si el campo no es múltiple, establecer el item guardado como valor seleccionado
        if (!this.currentReferenceField.isArray) {
          this.$set(this.formData, this.currentReferenceField.key, savedItem);
          // Emitir el cambio para notificar al componente padre
          this.$emit("input", this.formData);
        } else {
          this.$set(this.formData, this.currentReferenceField.key, [
            ...this.formData[this.currentReferenceField.key],
            savedItem,
          ]);
          // Emitir el cambio para notificar al componente padre
          this.$emit("input", this.formData);
        }
      }
      this.showReferenceModal = false;
    },
    removeOption(fieldKey, idToRemove) {
      if (this.formData[fieldKey] && Array.isArray(this.formData[fieldKey])) {
        const newValue = this.formData[fieldKey].filter(
          (item) => item._id !== idToRemove
        );
        this.$set(this.formData, fieldKey, newValue);
        this.onFieldChange(fieldKey, newValue);
      }
    },
    removeImage(key) {
      this.$set(this.formData, key, null);
      this.onFieldChange(key, null);
    },
    applyVisualRules() {
      const rules = this.getVisualRules ? this.getVisualRules() : [];

      this.internalFields.forEach((field) => {
        // Por defecto, no ocultar
        if (field.hide === true) {
          this.$set(field, "hide", true);
        } else {
          this.$set(field, "hide", false);
        }

        for (const rule of rules) {
          const targetValue = this.formData[rule.targetField];
          let shouldShow = true;

          switch (rule.condition) {
            case "equals":
              if (
                targetValue &&
                typeof targetValue === "object" &&
                targetValue._id
              ) {
                shouldShow = targetValue._id === rule.value;
              } else {
                shouldShow = targetValue === rule.value;
              }
              break;
            case "notEquals":
              if (
                targetValue &&
                typeof targetValue === "object" &&
                targetValue._id
              ) {
                shouldShow = targetValue._id !== rule.value;
              } else {
                shouldShow = targetValue !== rule.value;
              }
              break;
            case "contains":
              shouldShow = String(targetValue).includes(rule.value);
              break;
            case "notContains":
              shouldShow = !String(targetValue).includes(rule.value);
              break;
            case "isEmpty":
              shouldShow = !targetValue || targetValue === "";
              break;
            case "isNotEmpty":
              shouldShow = targetValue && targetValue !== "";
              break;
          }

          if (rule.fieldsToToggle.includes(field.key)) {
            const previousHide = field.hide;
            if (rule.action === "show") {
              this.$set(field, "hide", !shouldShow);
            } else {
              this.$set(field, "hide", shouldShow);
            }
          }
        }
      });

      // Propagar evento a subformularios
      this.$emit("visual-rules-update");
      // También emitir a hijos directos (subformularios)
      this.$nextTick(() => {
        this.$children.forEach((child) => {
          if (typeof child.applyVisualRules === "function") {
            child.applyVisualRules();
          }
        });
      });
    },
    /**
     * Handle field state changes from the rule engine
     * @param {Object} event - The event object containing fieldId and isCalculated
     */
    handleFieldStateChange(event) {
      const { fieldId, isCalculated } = event;

      const field = this.$el.querySelector(`#${fieldId}`);
      if (field) {
        if (isCalculated) {
          field.classList.add("calculated-field");
          field.title = "Campo calculado automáticamente";
        } else {
          field.classList.remove("calculated-field");
          field.title = "";
        }
      }
    },

    /**
     * Handle field value changes from the rule engine
     * @param {Object} event - The event object containing fieldId and value
     */
    handleFieldValueChange(event) {
      const { fieldId, value } = event;

      this.$set(this.formData, fieldId, value);
      this.$emit("input", this.formData);
    },

    /**
     * Aplicar mapeo bidireccional cuando se selecciona un campo de referencia
     * @param {Object} field - El campo de referencia
     * @param {Object} selectedReference - El elemento seleccionado
     */
    async applyReverseMapping(field, selectedReference) {
      // Prevenir bucle infinito
      if (this.isApplyingMapping) {
        return;
      }

      // Prevenir mapeos duplicados para el mismo campo
      const mappingKey = `${field.key}_${selectedReference._id}`;
      if (this.mappingInProgress.has(mappingKey)) {
        return;
      }

      // Verificar cache para evitar llamadas duplicadas
      const cacheKey = `${field.ref}_${this.selectedModel}_${selectedReference._id}`;
      if (this.mappingCache.has(cacheKey)) {
        const cachedMapping = this.mappingCache.get(cacheKey);
        this.applyCachedMapping(cachedMapping, field, selectedReference);
        return;
      }

      // Aplicar debounce para evitar múltiples llamadas rápidas
      if (this.mappingDebounceTimers.has(mappingKey)) {
        clearTimeout(this.mappingDebounceTimers.get(mappingKey));
      }

      return new Promise((resolve) => {
        const timer = setTimeout(async () => {
          try {
            await this.executeMapping(field, selectedReference, cacheKey);
            resolve();
          } catch (error) {
            console.error("Error in debounced mapping:", error);
            resolve();
          }
        }, 100); // 100ms debounce

        this.mappingDebounceTimers.set(mappingKey, timer);
      });
    },

    /**
     * Ejecutar el mapeo real
     */
    async executeMapping(field, selectedReference, cacheKey) {
      try {
        this.isApplyingMapping = true;
        this.mappingInProgress.add(`${field.key}_${selectedReference._id}`);

        // 1. Mapeo inverso: del modelo referenciado al modelo actual (B → A)
        const { data: reverseMappings } = await wencesApi.get(
          "/api/gotrading/model-reference-mapping",
          {
            params: {
              sourceModel: field.ref, // El modelo referenciado (ItemB)
              targetModel: this.selectedModel, // El modelo actual (ItemA)
            },
          }
        );

        if (reverseMappings.data && reverseMappings.data.length > 0) {
          const mapping = reverseMappings.data[0];

          // Obtener los datos completos del elemento referenciado
          const { data: referenceItem } = await wencesApi.get(
            `/api/gotrading/dynamic/${field.ref}/${selectedReference._id}`
          );

          if (referenceItem) {
            // Aplicar el mapeo inverso solo si no hay dependencias circulares
            const fieldsToUpdate = {};
            mapping.mappings.forEach((mappingRule) => {
              if (referenceItem[mappingRule.sourceField]) {
                let value = referenceItem[mappingRule.sourceField];

                // Limpiar campos del sistema si es necesario
                if (Array.isArray(value)) {
                  value = value.map((item) => {
                    const cleanItem = { ...item };
                    delete cleanItem._id;
                    delete cleanItem.editHistory;
                    delete cleanItem.createdAt;
                    delete cleanItem.updatedAt;
                    delete cleanItem.__v;
                    return cleanItem;
                  });
                }

                // Acumular cambios en lugar de aplicarlos inmediatamente
                fieldsToUpdate[mappingRule.targetField] = value;
              }
            });

            // Aplicar todos los cambios de una vez para evitar múltiples re-renders
            Object.keys(fieldsToUpdate).forEach((fieldKey) => {
              this.$set(this.formData, fieldKey, fieldsToUpdate[fieldKey]);
            });
          }
        }

        // 2. Mapeo directo: del modelo actual al modelo referenciado (A → B)
        const { data: directMappings } = await wencesApi.get(
          "/api/gotrading/model-reference-mapping",
          {
            params: {
              sourceModel: this.selectedModel, // El modelo actual (ItemA)
              targetModel: field.ref, // El modelo referenciado (ItemB)
            },
          }
        );

        if (directMappings.data && directMappings.data.length > 0) {
          const mapping = directMappings.data[0];

          // Aplicar el mapeo directo usando los datos actuales del formulario
          const fieldsToUpdate = {};
          mapping.mappings.forEach((mappingRule) => {
            if (this.formData[mappingRule.sourceField]) {
              let value = this.formData[mappingRule.sourceField];

              // Limpiar campos del sistema si es necesario
              if (Array.isArray(value)) {
                value = value.map((item) => {
                  const cleanItem = { ...item };
                  delete cleanItem._id;
                  delete cleanItem.editHistory;
                  delete cleanItem.createdAt;
                  delete cleanItem.updatedAt;
                  delete cleanItem.__v;
                  return cleanItem;
                });
              }

              // Acumular cambios en lugar de aplicarlos inmediatamente
              fieldsToUpdate[mappingRule.targetField] = value;
            }
          });

          // Aplicar todos los cambios de una vez para evitar múltiples re-renders
          Object.keys(fieldsToUpdate).forEach((fieldKey) => {
            this.$set(this.formData, fieldKey, fieldsToUpdate[fieldKey]);
          });
        }

        // Guardar en cache para futuras llamadas
        const mappingData = {
          reverseMappings: reverseMappings.data,
          directMappings: directMappings.data,
          referenceItem: referenceItem,
          timestamp: Date.now(),
        };
        this.mappingCache.set(cacheKey, mappingData);

        // Limpiar cache antiguo (más de 5 minutos)
        this.cleanupMappingCache();

        // Emitir el cambio al componente padre solo una vez
        this.$emit("input", this.formData);
      } catch (error) {
        console.error("Error applying bidirectional mapping:", error);
      } finally {
        this.isApplyingMapping = false;
        this.mappingInProgress.delete(`${field.key}_${selectedReference._id}`);
      }
    },

    /**
     * Aplicar mapeo desde cache
     */
    applyCachedMapping(cachedMapping, field, selectedReference) {
      try {
        // Aplicar mapeo inverso desde cache
        if (
          cachedMapping.reverseMappings &&
          cachedMapping.reverseMappings.length > 0
        ) {
          const mapping = cachedMapping.reverseMappings[0];
          const fieldsToUpdate = {};

          mapping.mappings.forEach((mappingRule) => {
            if (cachedMapping.referenceItem[mappingRule.sourceField]) {
              let value = cachedMapping.referenceItem[mappingRule.sourceField];

              // Limpiar campos del sistema si es necesario
              if (Array.isArray(value)) {
                value = value.map((item) => {
                  const cleanItem = { ...item };
                  delete cleanItem._id;
                  delete cleanItem.editHistory;
                  delete cleanItem.createdAt;
                  delete cleanItem.updatedAt;
                  delete cleanItem.__v;
                  return cleanItem;
                });
              }

              fieldsToUpdate[mappingRule.targetField] = value;
            }
          });

          // Aplicar cambios
          Object.keys(fieldsToUpdate).forEach((fieldKey) => {
            this.$set(this.formData, fieldKey, fieldsToUpdate[fieldKey]);
          });
        }

        // Aplicar mapeo directo desde cache
        if (
          cachedMapping.directMappings &&
          cachedMapping.directMappings.length > 0
        ) {
          const mapping = cachedMapping.directMappings[0];
          const fieldsToUpdate = {};

          mapping.mappings.forEach((mappingRule) => {
            if (this.formData[mappingRule.sourceField]) {
              let value = this.formData[mappingRule.sourceField];

              if (Array.isArray(value)) {
                value = value.map((item) => {
                  const cleanItem = { ...item };
                  delete cleanItem._id;
                  delete cleanItem.editHistory;
                  delete cleanItem.createdAt;
                  delete cleanItem.updatedAt;
                  delete cleanItem.__v;
                  return cleanItem;
                });
              }

              fieldsToUpdate[mappingRule.targetField] = value;
            }
          });

          // Aplicar cambios
          Object.keys(fieldsToUpdate).forEach((fieldKey) => {
            this.$set(this.formData, fieldKey, fieldsToUpdate[fieldKey]);
          });
        }

        // Emitir cambio
        this.$emit("input", this.formData);
      } catch (error) {
        console.error("Error applying cached mapping:", error);
      }
    },

    /**
     * Limpiar objeto para comparación (ignorar campos del sistema)
     */
    cleanObjectForComparison(obj) {
      if (!obj || typeof obj !== "object") return obj;

      // Si es un objeto reactivo de Vue, extraer solo los valores
      if (obj.__ob__ && obj.__ob__.value) {
        obj = obj.__ob__.value;
      }

      const clean = {};
      const systemFields = [
        "_id",
        "createdAt",
        "updatedAt",
        "__v",
        "editHistory",
        "__ob__",
      ];

      for (const [key, value] of Object.entries(obj)) {
        if (!systemFields.includes(key)) {
          if (Array.isArray(value)) {
            clean[key] = value.map((item) =>
              typeof item === "object"
                ? this.cleanObjectForComparison(item)
                : item
            );
          } else if (typeof value === "object" && value !== null) {
            clean[key] = this.cleanObjectForComparison(value);
          } else {
            clean[key] = value;
          }
        }
      }

      return clean;
    },

    /**
     * Limpiar cache antiguo
     */
    cleanupMappingCache() {
      const now = Date.now();
      const maxAge = 5 * 60 * 1000; // 5 minutos

      for (const [key, value] of this.mappingCache.entries()) {
        if (now - value.timestamp > maxAge) {
          this.mappingCache.delete(key);
        }
      }
    },
  },
  components: {
    ContentSkeleton,
    GroupIcon,
    Multiselect,
    Form: () => import("./Form2.vue"),
    UploadFile,
    ReferenceModal,
    AutoIncrementField,
    FieldImage,
    FieldText,
    FieldNumber,
    FieldList,
    FieldReference,
    FieldDate,
    FieldBoolean,
    FieldSelect,
    FieldTextList,
    FieldFile,
    FieldIcon,
  },
};
</script>
<style scoped>
.list {
  min-width: 130px;
}

/* En un grupo múltiple cada subcampo es una columna de la tabla, así que sin un
   mínimo los reference/list quedan tan angostos que no se lee la opción. */
.group-multiple .reference,
.group-multiple .list {
  min-width: 190px;
}

/* La tabla de un grupo múltiple puede ser más ancha que el formulario. En vez de
   desbordar el bloque (borde y fondo cortados a la mitad de la tabla), el bloque
   y el contenedor del campo crecen con ella; el scroll horizontal lo pone el
   contenedor de arriba (el modal), así no se crea un recorte nuevo que tape los
   desplegables de los multiselect. */
.group-multiple-block,
.group-multiple-field {
  width: -webkit-max-content;
  width: max-content;
  min-width: 100%;
  max-width: none;
}

/* Al crecer más que el formulario, el bloque se sale del fondo del modal: le
   damos el suyo. `--bs-card-bg` lo redefine dark.css en `#darkdesign`, así que
   acompaña el modo oscuro; el fallback blanco cubre el modo claro. */
.group-multiple-block {
  background-color: var(--bs-card-bg, #fff);
}
input[readonly],
textarea[readonly],
select[readonly] {
  background-color: #f0f0f0; /* Color de fondo gris claro */
  color: #a0a0a0; /* Color de texto gris */
  border: 1px solid #dcdcdc; /* Borde gris claro */
}

/* Forzar que el popup del multiselect siempre se abra hacia abajo */
:deep(.multiselect__content-wrapper) {
  top: 100% !important;
  bottom: auto !important;
  transform: none !important;
  z-index: 99999 !important;
  position: absolute !important;
  /* El desplegable no hereda el ancho (angosto) de la columna: igual que en
     Form.vue, se abre a 400px para que las opciones se lean completas. */
  width: 400px !important;
}

:deep(.multiselect__content) {
  max-height: 200px;
  overflow-y: auto;
}

/* Asegurar que la tabla y sus elementos no corten el popup */
.table-responsive {
  overflow: visible !important;
}

.table {
  overflow: visible !important;
}

.table td {
  position: relative;
  overflow: visible !important;
}

/* Asegurar que el contenedor del multiselect tenga el contexto de apilamiento correcto */
.multiselect-container {
  position: relative;
  z-index: 1;
}

.multiselect.is-active {
  z-index: 99999;
}

/* Ocultar el backdrop duplicado */
:deep(.modal-backdrop) {
  display: none;
}

.form-control {
  padding: 0 7px !important;
}

/* Estilos para tooltips */
.tooltip-icon {
  display: inline-block;
  position: relative;
}

.tooltip-icon:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.tooltip-icon:hover::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #333;
  margin-bottom: -5px;
  z-index: 1000;
}

/* Mejorar la apariencia del icono de info */
.tooltip-icon .md-icon {
  transition: color 0.2s ease;
}

.tooltip-icon:hover .md-icon {
  color: #007bff !important;
}

</style>
<style>
@media (max-width: 767.98px) {
  .form2-field-row > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
